import useDialogStore from '@/Features/Core/store/useDialogStore';
import { useCallback } from 'react';

export const useCustomAction = (property) => {
  const { setShowImageModalAttachments } = useDialogStore();

  // Dictionary of custom actions
  const customActions = {
    attachment: () => {
      setShowImageModalAttachments(true);
    },
  };

  const getAction = useCallback(() => {
    const customAction = customActions[property];
    if (customAction) {
      return customAction;
    }
    return () => {};
  }, [property]);

  return getAction();
};
